/**
 * HTX Exchange Metadata
 */

import { HTX_WS_CHANNELS, HTX_WS_TOPOLOGY } from './ws';

import type { ExchangeId, ExchangeMetadata } from '../../lib/types';

export const HTX_METADATA: ExchangeMetadata = {
  id: 'htx' as ExchangeId,
  restDocs: ['https://huobiapi.github.io/docs/spot/v1/en/'],
  wsDocs: ['https://huobiapi.github.io/docs/spot/v1/en/#websocket-market-data'],
  wsTopology: HTX_WS_TOPOLOGY,
  wsChannels: HTX_WS_CHANNELS,
  notes: [
    'All WebSocket messages are gzip-compressed.',
    'Symbol format: lowercase concatenation (e.g., btcusdt).',
    'Server sends ping frames that must be acknowledged with pong.',
    'Orderbook is snapshot-based (not incremental).',
    'Kline timestamps are in SECONDS (must multiply by 1000).',
  ],
};
